module.exports = __webpack_public_path__ + "static/img/m701.ceccbb20.gif";